import React from "react";
import Item from "./Item";
import cx from "classnames";
import styles from "./FeaturedItems.module.scss";
import ImagesGallery from "@components/ImagesGallery";
import { usePageContext } from "@providers/PageProvider";
import { dinningPage } from "@utils/helper";
import _ from "lodash";
export default function FeaturedItems() {
  const { pageData } = usePageContext();
  const restaurant: any = dinningPage.formatRestaurant(pageData);
  const cuisine: any = dinningPage.formatCuisine(pageData);
  return (
    <div
      data-scroll-section
      className={cx("flex flex-col items-center", styles.section)}
    >
      <Item
        className={cx(styles.item1)}
        images={[
          {
            ..._.get(restaurant, "image"),
            placement: "topRight",
          },
        ]}
        aside={{
          placement: "bottomLeft",
          className: cx(styles.asideItem1),
          content: {
            className: cx(styles.contentItem1),
            title: _.get(restaurant, "title"),
            text: _.get(restaurant, "description"),
          },
        }}
      />
      <Item
        className={cx(styles.item2)}
        images={{
          node: (
            <ImagesGallery
              isAuto={_.get(cuisine, "slider.isAuto")}
              interval={_.get(cuisine, "slider.interval")}
              className={cx(styles.galleryItem2)}
              galleryName={"galleryItem2"}
              images={_.get(cuisine, "slider.slides", [])}
            />
          ),
          placement: "left",
        }}
        aside={{
          placement: "right",
          className: cx(styles.asideItem2),
          content: {
            className: cx(styles.contentItem2),
            title: _.get(cuisine, "title"),
            text: _.get(cuisine, "description"),
          },
        }}
      />
    </div>
  );
}
